import React from "react"
import styled, { css } from "react-emotion"
import {
    Input,
    Label,
    Button,
    ButtonGroup,
    Collapsible,
    Container,
    Divider,
    Section,
    Dropdown,
    ColorPicker,
} from "ui"

export const Field = props => (
    <Container centered={true} padding="none">
        {props.children}
    </Container>
)
export const SmallField = props => (
    <Container centered padding="none" marginLeft="medium" style={{ width: 115 }}>
        {props.children}
    </Container>
)

export const TinyLabel = props => (
    <Label
        size="fontS"
        {...props}
        style={{ width: 40, margin: 0, padding: "3px 3px", fontSize: "10px", ...props.style }}
    />
)
export const FieldLabel = props => <Label size="fontS" style={{ width: 40 }} {...props} />
export const SmallInput = props => (
    <Input
        style={{ width: 50 }}
        value={getBlockStyle(props.context, props.field)}
        onChange={event =>
            props.context.actions.updateStyle(
                props.context.block.id,
                props.field,
                event.target.value
            )
        }
        {...props}
    />
)

export const SmallDropdown = props => <Dropdown style={{ width: "160px" }} {...props} />
export const SmallButton = props => (
    <Button
        {...props}
        style={{ ...props.style, height: "30px", width: "30px" }}
        {...{ color: props.active ? "success" : "primary" }}
    />
)
export const InvertedImg = props => (
    <img
        style={{
            filter: "invert(100%)",
            height: "17px",
            transform: `rotate(${props.rotate || 0}deg`,
        }}
        {...props}
    />
)

export const cssStyled = css`
    background-color: rgb(44, 49, 60);
    color: white;
    font-family: Consolas, Menlo, monosp ace;
    margin: 0px;
    height: 141px;
    width: 205px;
    margin: 10px;
`

export const PaddingMarginInput = ({ context }) => (
    <Section padding="none" margin="none">
        <DummyMargins>
            <Container padding="none" margin="none">
                <TinyLabel style={{ marginTop: 2, marginRight: 0, marginLeft: "-92px" }}>
                    Margin
                </TinyLabel>
                <MarginMeasuringIndicator />
                <TinyInput context={context} field="marginTop" />
            </Container>
            <Container padding="none" margin="none" style={{ alignItems: "center" }}>
                <TinyInput context={context} field="marginLeft" />
                <DummyBlock>
                    <Container padding="none" margin="none">
                        <TinyLabel style={{ marginTop: 2, marginRight: 0, marginLeft: "-53px" }}>
                            Padding
                        </TinyLabel>
                        <PaddingMeasuringIndicator />
                        <TinyInput context={context} field="paddingTop" />
                    </Container>
                    <Container padding="none" margin="none" style={{ alignItems: "center" }}>
                        <TinyInput context={context} field="paddingLeft" />
                        <DummyPadding />
                        <TinyInput context={context} field="paddingRight" />
                    </Container>
                    <TinyInput context={context} field="paddingBottom" />
                </DummyBlock>
                <TinyInput context={context} field="marginRight" />
            </Container>
            <TinyInput context={context} field="marginBottom" />
        </DummyMargins>
    </Section>
)

export const DummyBlock = styled("div")`
    border: 1px solid #6d727b;
    width: 140px;
    height: 100px;
    verticalalign: middle;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 5px;
    padding: 1px;
`

export const DummyPadding = styled("div")`
    border: 1px dashed #666;
    width: 70px;
    height: 55px;
    margin: 2px;
`

export const DummyMargins = styled("div")`
    border: 1px dashed #666;
    width: 100%;
    height: 100;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 5px;
`
export const TinyInput = props => (
    <Input
        style={{ width: 30, padding: 2, fontSize: "10px" }}
        value={getBlockStyle(props.context, props.field)}
        onChange={event =>
            props.context.actions.updateStyle(
                props.context.block.id,
                props.field,
                event.target.value
            )
        }
        {...props}
    />
)

export const PaddingMeasuringIndicator = props => (
    <div
        style={{
            height: 22,
            width: 7,
            margin: "0px 7px 0px 1px",
            borderTop: "1px solid  #666666",
            borderBottom: "1px solid  #666666",
        }}
    >
        <div style={{ width: "4px", height: "100%", borderRight: "1px solid #666666" }} />
    </div>
)
export const MarginMeasuringIndicator = props => (
    <div
        style={{
            height: 26,
            width: 7,
            margin: "-3px 40px -3px 2px",
            borderTop: "1px solid  #666666",
            borderBottom: "1px solid  #666666",
        }}
    >
        <div style={{ width: "4px", height: "100%", borderRight: "1px solid #666666" }} />
    </div>
)

export const getBlockStyle = (context, attrib) => {
    let deviceType = context.deviceType === "desktop" ? "default" : context.deviceType
    return (
        (context.block &&
            context.block.config.style &&
            context.block.config.style[deviceType] &&
            context.block.config.style[deviceType][attrib]) ||
        ""
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/ui/Pane.js